module.exports = __webpack_public_path__ + "img/default.98a70efa.jpg";